import {useCallback} from "react";
import {buildCityKey, sumMacroData} from "../utils/useMapUtils";
import {generateColors} from "../utils/colorScales";

export function useColorGradient(allMapCities, beneficiariosDemo, sortOption, scaleType) {
  return useCallback(() => {
    if (!allMapCities.length || !beneficiariosDemo.valuesCity.length) return null;

    let valoresEstado = [];
    let dicionarioCidades = {};

    for (let i = 0; i < beneficiariosDemo.valuesCity.length; i++) {
      let cidade = beneficiariosDemo.valuesCity[i][0];

      const cityKey = buildCityKey(cidade, sortOption)

      if (allMapCities.includes(cityKey)) {
        const valor = sumMacroData(beneficiariosDemo.valuesCity[i]);
        valoresEstado.push(valor);
        dicionarioCidades[cityKey] = valor;
      }
    }

    if (valoresEstado.length === 0) return null;

    const cidadesOrdenadas = Object.entries(dicionarioCidades).sort((a, b) => b[1] - a[1]);
    const redScale = generateColors(cidadesOrdenadas, scaleType);

    const coresValues = Object.values(redScale);
    const validColors = coresValues.filter(c => !isNaN(c));

    if (validColors.length === 0) return null;

    const minColor = Math.min(...validColors);
    const maxColor = Math.max(...validColors);
    const midColor = Math.round((minColor + maxColor) / 2);

    const colorStops = [
      `rgb(${minColor}, 0, 0) 0%`,
      `rgb(${midColor}, 0, 0) 50%`,
      `rgb(${maxColor}, 0, 0) 100%`
    ];

    return `linear-gradient(to right, ${colorStops.join(", ")})`;
  }, [allMapCities, beneficiariosDemo.valuesCity, scaleType, sortOption]);
}
